import axiosClient from './axiosClient';

/** Endpoints for the authenticated ADMIN role (/api/v1/admin/**). */
const adminService = {
  getStats: () => axiosClient.get('/admin/stats'),

  // (Technician & booking approval moved to reviewService — /review/**)

  // Users
  listUsers: (params = {}) => axiosClient.get('/admin/users', { params }),
  updateUserStatus: (id, status) =>
    axiosClient.patch(`/admin/users/${id}/status`, { status }),
  updateUserRole: (id, role) => axiosClient.patch(`/admin/users/${id}/role`, { role }),
  deleteUser: (id, force = false) =>
    axiosClient.delete(`/admin/users/${id}`, { params: force ? { force: true } : {} }),

  // Bookings oversight
  listBookings: (params = {}) => axiosClient.get('/admin/bookings', { params }),

  // Technician type catalogue
  listTechnicianTypes: () => axiosClient.get('/admin/technician-types'),
  createTechnicianType: (payload) => axiosClient.post('/admin/technician-types', payload),
  updateTechnicianType: (id, payload) =>
    axiosClient.put(`/admin/technician-types/${id}`, payload),
  deleteTechnicianType: (id) => axiosClient.delete(`/admin/technician-types/${id}`),
};

export default adminService;
